import axios from "axios"
const apiToken = JSON.parse(localStorage.getItem("authUser"))
let UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))

const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

// Add Policy-Type like health insurance, Life insurance etc...
export const addPolicyTypeAPI = async payload => {
  try {
    const data = {
      policy_id: payload,
    }

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/all-policies-link`, data, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

// view-policies

export const viewPolicyTypeAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(`${apiBaseUrl}/view-policy-types`, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

// add-policy for customer

export const addPolicyCustomerAPI = async formData => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: apiToken, // Assuming token needs "Bearer" prefix
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/add-policy`, formData, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding policy:", error)
    throw error
  }
}

export const DuplicatePolicyNumberAPI = async payload => {
  try {

    const data = {
     policyNumber : payload
    }
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/check-duplicatePolicy`, data, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding policy:", error)
    throw error
  }
}


export const AddVehicleMakeModeAPI = async formData => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.post(`${apiBaseUrl}/new-vehicle-entry`, formData, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding policy:", error)
    throw error
  }
}
// /policy-by-customer

export const getPolicyCustomerAPI = async payload => {
  // try {
    const data = {
      customer_id: payload,
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/policy-by-customer`,
      data,
      {
        headers,
      }
    )
    return response
  // } catch (error) {
  //   //console.error("Error adding lead:", error)
  //   return error
  // }
}

// update policy to customer

export const updatePolicyCustomerAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: apiToken, // Assuming token needs "Bearer" prefix
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/update-policy`, payload, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

// get policy by customer id

export const getPolicyCustomerByIDAPI = async payload => {
  try {
    const data = payload

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/view-cust-policy`, data, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

// get company name /allCompanies

// get policy name /allPolicyTypes
export const GetAllPolicyTypesAPI = async () => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(`${apiBaseUrl}/allInsuranceTypes`)
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

export const GetAllCompaniesAPI = async payload => {
  try {
    const data = {
      insurancetype_id: payload,
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/allInsuranceCompanies`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

// get sub-policy /allPolicySub-Types
export const GetAllLOBAPI = async payload => {
  try {
    const data = {
      insurancetype_id: payload,
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/allLOB`, data, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error in All LOB:", error)
    throw error
  }
}

// Get ALL SUB LOB
export const GetAllSubLOBAPI = async payload => {
  try {
    const data = {
      lob_id: payload,
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/allSubLOB`, data)
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

// Linking Policy API

export const PolicyLinkingAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: apiToken, // Assuming token needs "Bearer" prefix
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/link-policy`, payload, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error linking Policy:", error)
    throw error
  }
}

export const ProductName = async payload => {
  try {
    const data = {
      policy_id: payload,
    }

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/all-policies-link`, data, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

// /get-gst-rates

export const GstAPI = async () => {
  try {
    const response = await axios.get(`${apiBaseUrl}/get-gst-rates`)
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

export const GstLOBwiseFields = async () => {
  try {
    const response = await axios.get(`${apiBaseUrl}/get-gst-rates`)
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

///get-AdditionalFieldName

export const AdditionalFieldNameAPI = async payload => {
  try {
    const data = {
      sublob_id: payload,
    }

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/get-AdditionalFieldName`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

// GET STATE
export const GetSTATEAPI = async () => {
  try {
    const response = await axios.get(`${apiBaseUrl}/get-AllStates`)
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}


export const GetRegistationNumAPI = async payload => {
  try {
    const data = {
      state: payload,
    }

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/get-registration_number`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}


export const GetBrandAPI = async () => {
  try {
    const response = await axios.get(`${apiBaseUrl}/get-brandNames`)
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

///get-modelNames

export const GetModelNameAPI = async payload => {
  try {
    const data = {
      brand_name: payload,
    }

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/get-modelNames`,
      data,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}


export const GetPolicyReportAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/get-PolicyReport`,
      payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error get policy report:", error)
    throw error
  }
}



export const GetReferencesAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(`${apiBaseUrl}/get-References`,{headers,})
    return response
  } catch (error) {
    console.error("Error get policy report:", error)
    throw error
  }
}


// Delete policy 

export const DeletePolicyAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/delete-policy`,
      payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error get policy report:", error)
    throw error
  }
}


export const reqPolicyReportAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/request-policy-report`,
      payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error while requesting policy report:", error)
    throw error
  }
}


export const PolicyReportStatusAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/report-status`,
      payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error while requesting policy report status:", error)
    throw error
  }
}


export const downloadPolicyReportAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(
      `${apiBaseUrl}/download-report/${payload}`,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error while Downloding policy report:", error)
    throw error
  }
}




export const getAllPolicyReportsAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(
      `${apiBaseUrl}/user-reports`,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error while Getting all policy report:", error)
    throw error
  }
}



export const getCommissionPermissionAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.get(
      `${apiBaseUrl}/get-CommissionPermission`,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error while Get commission permission:", error)
    throw error
  }
}

export const uploadPolicyFileAPI = async payload => {
    let apiToken = await JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/uploadPolicyFiles`, payload, {
      headers,
    })
    return response
}


export const getUploadPolicyFileAPI = async payload => {
  let apiToken = await JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  const response = await axios.post(`${apiBaseUrl}/viewPolicyFile`, payload, {
    headers,
  })
  return response
}

export const deletePolicyFileAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.post(`${apiBaseUrl}/deletePolicyfile`, payload, {
    headers,
  })
}

export const editPolicyFilesAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.post(`${apiBaseUrl}/editPolicyFileName`,payload, {
    headers,
  })
}

export const uploadPolicyPdfAPI = async (formData) => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
    }

    const response = await axios.post(
      `${apiBaseUrl}/uploadWwingsPdf`,
      formData,
      { headers }
    )

    return response
  } catch (error) {
    throw error
  }
}

// Get OCR Data
export const getPolicyByFileIdAPI = async (file_id) => {
  try {
    const apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      Authorization: apiToken,
    }

    const response = await axios.get(
      `${apiBaseUrl}/getPolicyByFileId?file_id=${file_id}`,
      { headers }
    )

    return response
  } catch (error) {
    throw error
  }
}

export const GetIRDAPolicyReportAPI = async payload => {
  try {

    let apiToken =
      JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/get-IRDAPolicyReport`,
      payload,
      {
        headers,
      }
    )

    return response

  } catch (error) {

    console.error(
      "Error get IRDA policy report:",
      error
    )

    throw error
  }
}